/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ContractType } from "~/models";

export const contractTypeOptions = [
  {
    label: "Fixed",
    value: ContractType.FIXED,
  },
  {
    label: "Indefinite",
    value: ContractType.INDEFINITE,
  },
];
